import { Trans } from '@lingui/react/macro';

import { DefectPhotos } from '@/components/DefectPhotos';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import InlineText from '@/design_system/Typography/InlineText';
import { TEMPORARY_ID_PREFIX } from '@/models/article';
import { ArticleDefectWithRelations } from '@/models/request';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { createBEMClasses } from '@/utils/classname';

import { getEditedFields } from './getEditedFields';

const { element } = createBEMClasses('defect-card');

export const DefectPhotosMobile = ({
  defect,
  previousDefect,
}: {
  defect?: ArticleDefectWithRelations;
  previousDefect?: ArticleDefectWithRelations;
}) => {
  const { errors } = useArticleContext();

  const defectOrPreviousDefect = defect ?? previousDefect;

  if (!defectOrPreviousDefect?.media.length) {
    return null;
  }

  return (
    <div
      className={element('photos', {
        edited: getEditedFields({ defect, previousDefect }).isPhotosEdited,
      })}
    >
      <DefectPhotos
        defect={defect ?? previousDefect}
        size="medium"
        isDisabled
        isInvalid={
          defect && errors.defects?.defects?.find((def) => def.id === defect?.id)?.missingPhotos
        }
      />
    </div>
  );
};

export const DefectPhotosInput = ({
  defect,
  previousDefect,
}: {
  defect?: ArticleDefectWithRelations;
  previousDefect?: ArticleDefectWithRelations;
}) => {
  const { errors, view } = useArticleContext();

  const isEditable =
    !!defect && view.defects.fields.photo.editable && !defect.id.startsWith(TEMPORARY_ID_PREFIX);

  return (
    <div
      className={element('photos', {
        edited: getEditedFields({ defect, previousDefect }).isPhotosEdited,
      })}
    >
      <DefectPhotos
        defect={defect ?? previousDefect}
        size="medium"
        isDisabled={!isEditable}
        isInvalid={
          defect && errors.defects?.defects?.find((def) => def.id === defect.id)?.missingPhotos
        }
        secondaryActionIconOnly
        label={
          <>
            <InlineText size="100" color="secondary">
              <Trans id="defect-card.photos.label">Photos</Trans>
            </InlineText>
            {isEditable && !view.defects.fields.photo.required && <OptionalLabel />}
          </>
        }
      />
    </div>
  );
};
